export function getCurrentYearMonth() {
  const currentDate = new Date()
  const year = currentDate.getFullYear()
  const month = String(currentDate.getMonth() + 1).padStart(2, '0') // Adding 1 to month as it is zero-based

  return `${year}-${month}`
}
